<!-- src/app/app.component.html -->

<lib-layout [navLinks]="navLinks">
  <router-outlet />
</lib-layout>